/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React from "react";

export function TermOfUseText() {
  return (
    <>
      <p className="c8">
        <span className="c0">
          Por favor, leia atentamente os termos e condi&ccedil;&otilde;es de uso
          aqui apresentados, antes de utilizar o aplicativo HU Digital.
        </span>
      </p>
      <p className="c8">
        <span className="c0">
          Ao acessar e utilizar os servi&ccedil;os do HU Digital, voc&ecirc;
          concorda com as condi&ccedil;&otilde;es de uso do presente Termo, bem
          como com as condi&ccedil;&otilde;es estabelecidas no &quot;Termo de
          Uso e Aviso de Privacidade&quot; da Empresa Brasileira de
          Servi&ccedil;os Hospitalares (HU Brasil), dispon&iacute;vel no
          endere&ccedil;o eletr&ocirc;nico{" "}
          <a
            href="https://gov.br/ebserh/pt-br/acesso-a-informacao/tratamento-de-dados-pessoais/TERMODEUSOEAVISODEPRIVACIDADE1.pdf"
            target="_blank"
            rel="noreferrer"
          >
            gov.br/ebserh/pt-br/acesso-a-informacao/tratamento-de-dados-pessoais/TERMODEUSOEAVISODEPRIVACIDADE1.pdf
          </a>
          .{" "}
        </span>
      </p>
      <p className="c8">
        <span className="c0">
          Este Termo &eacute; um acordo vinculativo entre o usu&aacute;rio e o
          aplicativo HU Digital, que abrange o acesso e uso do aplicativo, o que
          inclui o uso das informa&ccedil;&otilde;es, dados, ferramentas,
          produtos, servi&ccedil;os e outros conte&uacute;dos dispon&iacute;veis
          por meio deste.
        </span>
      </p>
      <p className="c8">
        <span className="c4">
          <strong>Defini&ccedil;&otilde;es</strong>
        </span>
      </p>
      <ol className="c5 lst-kix_list_1-0 start" type="a">
        <li className="c17 li-bullet-0">
          <span className="c4">
            <strong>Usu&aacute;rios</strong>
          </span>
          <span className="c0">
            : todos os usu&aacute;rios dos sistemas tecnol&oacute;gicos do HU
            Brasil em suas diferentes modalidades;
          </span>
        </li>
        <li className="c17 li-bullet-0">
          <span className="c4">
            <strong>Usu&aacute;rio-Paciente</strong>
          </span>
          <span className="c0">
            : pessoa que recebe servi&ccedil;os de assist&ecirc;ncia &agrave;
            sa&uacute;de por parte do Usu&aacute;rio-Profissional, cujos dados
            pessoais podem ser inseridos nos sistemas tecnol&oacute;gicos do HU
            Brasil, sob responsabilidade deste, e que esteja cadastrado como
            paciente, possibilitando-lhe o acesso a suas
            informa&ccedil;&otilde;es pessoais de sa&uacute;de.
          </span>
        </li>
        <li className="c17 li-bullet-0">
          <span className="c4">
            <strong>Usu&aacute;rio-Profissional</strong>
          </span>
          <span className="c0">
            : todo usu&aacute;rio cadastrado como profissional de sa&uacute;de
            que possua as autoriza&ccedil;&otilde;es necess&aacute;rias para
            registros cl&iacute;nicos e cuja atua&ccedil;&atilde;o dependa do
            acesso a dados pessoais sens&iacute;veis relacionados &agrave;
            sa&uacute;de de pacientes cadastrados nos sistemas
            tecnol&oacute;gicos da HU Brasil, incluindo m&eacute;dicos,
            enfermeiros e outros profissionais de sa&uacute;de habilitados.
            Nesta modalidade, poder&atilde;o ser editados perfis distintos de
            acesso conforme a atividade desempenhada pelo profissional, cabendo
            ao Usu&aacute;rio-Gestor realizar tal cadastramento.
          </span>
        </li>
        <li className="c17 li-bullet-0">
          <span className="c4">
            <strong>Usu&aacute;rio-Gestor</strong>
          </span>
          <span className="c0">
            : todo usu&aacute;rio cadastrado como gestor e que possua
            autoriza&ccedil;&atilde;o necess&aacute;ria para habilitar outros
            profissionais a acessar dados dos pacientes assistidos nas unidades
            de sa&uacute;de da HU Brasil.
          </span>
        </li>
        <li className="c7 li-bullet-0">
          <span className="c4">
            <strong>Aplicativo</strong>{" "}
          </span>
          <span className="c0">
            &ndash; software gratuito dispon&iacute;vel para
            instala&ccedil;&atilde;o em dispositivos m&oacute;veis, utilizado
            para disponibiliza&ccedil;&atilde;o de informa&ccedil;&otilde;es de
            pacientes da Rede HU Brasil.
          </span>
        </li>
      </ol>
      <p className="c8 c13">
        <span className="c0" />
      </p>
      <p className="c21">
        <span className="c11">
          <strong>IMPORTANTE:</strong>
        </span>
      </p>
      <ul className="c5 lst-kix_list_4-0 start">
        <li className="c15 li-bullet-0">
          <span className="c9">
            Para utilizar o&nbsp;aplicativo&nbsp;&eacute; necess&aacute;ria a
            aceita&ccedil;&atilde;o do usu&aacute;rio a este termo.
          </span>
        </li>
        <li className="c22 c25 li-bullet-0">
          <span className="c9">
            A aceita&ccedil;&atilde;o &eacute; confirmada quando o
            usu&aacute;rio clica no bot&atilde;o &ldquo;aceito&rdquo; e declara
            ter ci&ecirc;ncia e concordar com todo o seu conte&uacute;do de
            forma livre e informada.
          </span>
        </li>
        <li className="c6 li-bullet-0">
          <span className="c9">
            Caso o usu&aacute;rio n&atilde;o concorde com qualquer
            disposi&ccedil;&atilde;o, recomenda-se que n&atilde;o utilize
            o&nbsp;aplicativo.
          </span>
        </li>
      </ul>
      <p className="c8 c13">
        <span className="c0 c23" />
      </p>
      <p className="c13 c27">
        <span className="c0" />
      </p>
      <p className="c16">
        <span className="c4">
          <strong>Descri&ccedil;&atilde;o do Servi&ccedil;o HU Digital</strong>
        </span>
      </p>
      <p className="c2">
        <span>
          O Servi&ccedil;o HU Digital consiste na disponibiliza&ccedil;&atilde;o
          de uma plataforma tecnol&oacute;gica de informa&ccedil;&atilde;o e o
          gerenciamento de dados sens&iacute;veis de sa&uacute;de de
          usu&aacute;rios, que visam
        </span>
        <span className="c24">
          &nbsp;garantir o acesso &agrave; informa&ccedil;&atilde;o em meio
          digital necess&aacute;rio a prover assist&ecirc;ncia &agrave;
          sa&uacute;de, continuidade do cuidado do cidad&atilde;o e os meios
          administrativos para a adequada, eficiente e segura gest&atilde;o
          hospitalar.
        </span>
      </p>
      <p className="c2">
        <span className="c0">
          Os dados s&atilde;o coletados a partir de sistemas tecnol&oacute;gicos
          da HU Brasil e de sistemas externos.
        </span>
      </p>
      <p className="c2">
        <span>O objetivo do HU Digital &eacute;</span>
        <span className="c24">
          &nbsp;promover o acesso do cidad&atilde;o, dos profissionais de
          sa&uacute;de, estabelecimentos de sa&uacute;de p&uacute;blicos ou
          privados e gestores de sa&uacute;de &agrave;s
          informa&ccedil;&otilde;es em sa&uacute;de&nbsp;dos pacientes dos
          Hospitais Universit&aacute;rios Federais, por meio de plataforma
          m&oacute;vel e de servi&ccedil;os digitais da HU Brasil.
        </span>
      </p>
      <p className="c13 c20">
        <span className="c4" />
      </p>

      <ol className="c5 lst-kix_list_2-0 start">
        <li className="c3 li-bullet-1">
          <span className="c4">
            <strong>Respeito &agrave;s Leis:</strong>
          </span>
        </li>
        <ol className="c5 lst-kix_list_2-1 start">
          <li className="c1 li-bullet-2">
            <span className="c0">
              O usu&aacute;rio concorda em utilizar o aplicativo apenas para as
              finalidades previstas neste Termo e em conformidade com as
              limita&ccedil;&otilde;es legais, bem como as pol&iacute;ticas
              p&uacute;blicas aplic&aacute;veis no Brasil.
            </span>
          </li>
          <li className="c1 li-bullet-2">
            <span className="c0">
              A altera&ccedil;&atilde;o n&atilde;o autorizada dos
              conte&uacute;dos deste aplicativo &eacute; expressamente proibida.
            </span>
          </li>
        </ol>

        <p className="c12">
          <span className="c4" />
        </p>
        <li className="c3 li-bullet-3">
          <span className="c4">
            <strong>Crian&ccedil;as e adolescentes:</strong>
          </span>
        </li>
        <ol className="c5 lst-kix_list_2-1 start">
          <li className="c1 li-bullet-2">
            <span className="c0">
              {" "}
              A utiliza&ccedil;&atilde;o do aplicativo n&atilde;o &eacute;
              indicada para crian&ccedil;as e adolescentes, nos termos do Art.
              14 da Lei 13.709/2018 (LGPD).{" "}
            </span>
            {/* <span className="c0">
              A utiliza&ccedil;&atilde;o do aplicativo &eacute; indicada somente para
              indiv&iacute;duos de 12 (doze) anos de idade ou mais, Adolescentes
              segundo o Estatuto da Crian&ccedil;a e Adolescente, poder&atilde;o
              utilizar o aplicativo sob orienta&ccedil;&atilde;o dos
              respons&aacute;veis legais.

            </span> */}
          </li>
          {/* <li className="c1 li-bullet-4">
            <span className="c0">
              N&atilde;o s&atilde;o coletadas intencionalmente
              informa&ccedil;&otilde;es de identifica&ccedil;&atilde;o pessoal de
              crian&ccedil;as, exceto em urg&ecirc;ncias relacionadas &agrave;
              necessidade de entrar em contato com pais ou respons&aacute;veis e/ou
              para prote&ccedil;&atilde;o da crian&ccedil;a e do adolescente.
            </span>
          </li> */}
          {/* <li className="c1 li-bullet-2">
            <span className="c0">
              O usu&aacute;rio respons&aacute;vel por um menor que tiver
              ci&ecirc;ncia de que este forneceu informa&ccedil;&otilde;es pessoais,
              deve entrar em contato com a Ebserh, por meio da Ouvidoria, para que
              sejam realizadas as a&ccedil;&otilde;es adequadas.

            </span>
          </li> */}
        </ol>

        <p className="c12">
          <span className="c0" />
        </p>
        <li className="c3 li-bullet-5">
          <span className="c4">
            <strong>Responsabilidade pelo conte&uacute;do:</strong>
          </span>
        </li>
        <ol className="c5 lst-kix_list_2-1 start">
          <li className="c1 li-bullet-6">
            <span className="c0">
              O HU Digital n&atilde;o &eacute; respons&aacute;vel pelo
              conte&uacute;do de informa&ccedil;&otilde;es eventualmente
              trocadas pelos usu&aacute;rios entre si e entre o usu&aacute;rio e
              o aplicativo.
            </span>
          </li>
          <li className="c1 li-bullet-2">
            <span className="c0">
              O usu&aacute;rio concorda que &eacute; o &uacute;nico
              respons&aacute;vel pela sua pr&oacute;pria conduta e pela
              veracidade das informa&ccedil;&otilde;es fornecidas enquanto
              utilizar o servi&ccedil;o e que &eacute; respons&aacute;vel pelas
              consequ&ecirc;ncias que resultem do fornecimento intencional de
              dados incorretos.
            </span>
          </li>
          <li className="c1 li-bullet-4">
            <span className="c0">
              O usu&aacute;rio concorda que, ao utilizar o HU Digital,
              n&atilde;o ir&aacute; publicar, enviar, distribuir ou divulgar
              conte&uacute;do ou informa&ccedil;&atilde;o de car&aacute;ter
              difamat&oacute;rio, obsceno ou il&iacute;cito, inclusive
              informa&ccedil;&otilde;es de propriedade exclusiva pertencentes a
              outras pessoas ou empresas, bem como marcas registradas ou
              informa&ccedil;&otilde;es protegidas por direitos autorais, sem a
              expressa autoriza&ccedil;&atilde;o do detentor desses direitos.
              &Eacute; de responsabilidade do usu&aacute;rio o compartilhamento
              de quaisquer informa&ccedil;&otilde;es ou dados de sa&uacute;de de
              terceiros.
            </span>
          </li>
        </ol>

        <p className="c12">
          <span className="c0" />
        </p>
        <li className="c3 li-bullet-3">
          <span className="c4">
            <strong>Acessibilidade ao conte&uacute;do:</strong>
          </span>
        </li>
        <ol className="c5 lst-kix_list_2-1 start">
          <li className="c1 li-bullet-2">
            <span className="c0">
              Para acesso ao HU Digital, o usu&aacute;rio dever&aacute; possuir
              cadastro no login &uacute;nico{" "}
              <a href="https://gov.br" target="_blank" rel="noreferrer">
                gov.br
              </a>{" "}
              ou possuir cadastro no sistema de identifica&ccedil;&atilde;o do
              HU Brasil, caso seja um usu&aacute;rio-profissional ou
              usu&aacute;rio-gestor vinculado &agrave; Rede HU Brasil.
            </span>
          </li>
        </ol>

        <p className="c12">
          <span className="c0" />
        </p>
        <p className="c12">
          <span className="c0" />
        </p>
        <p className="c12">
          <span className="c0" />
        </p>
        <p className="c12">
          <span className="c0" />
        </p>
        <li className="c3 li-bullet-3">
          <span className="c4">
            <strong>Propriedade intelectual:</strong>
          </span>
        </li>
        <ol className="c5 lst-kix_list_2-1 start">
          <li className="c1 li-bullet-2">
            <span className="c0">
              O HU Brasil &eacute; detentor do direito autoral deste aplicativo
              e dos conte&uacute;dos nele produzidos e apresentados neste
              aplicativo, n&atilde;o se aplicando tal crit&eacute;rio &agrave;s
              informa&ccedil;&otilde;es consideradas como de dom&iacute;nio
              p&uacute;blico ou de utilidade p&uacute;blica.
            </span>
          </li>
          <li className="c1 li-bullet-2">
            <span className="c0">
              O aplicativo HU Digital &eacute; um software de propriedade
              intelectual da HU Brasil.
            </span>
          </li>
        </ol>

        <p className="c12">
          <span className="c0" />
        </p>
        <li className="c3 li-bullet-3">
          <span className="c4">
            <strong>Leis, regulamentos, direitos e deveres:</strong>
          </span>
        </li>
        <ol className="c5 lst-kix_list_2-1 start">
          <li className="c1 li-bullet-2">
            <span className="c0">
              Todas as informa&ccedil;&otilde;es de usu&aacute;rios ou
              profissionais de sa&uacute;de s&atilde;o protegidas, de acordo com
              a Lei Geral de Prote&ccedil;&atilde;o de Dados Pessoais (LGPD),
              Lei N&ordm; 13.709, de 14 de agosto de 2018, dispon&iacute;vel no
              endere&ccedil;o eletr&ocirc;nico{" "}
              <a
                href="http://www.planalto.gov.br/ccivil_03/_ato2015-2018/2018/lei/l13709.htm"
                target="_blank"
                rel="noreferrer"
              >
                http://www.planalto.gov.br/ccivil_03/
                _ato2015-2018/2018/lei/l13709.htm
              </a>{" "}
            </span>
          </li>
          <li className="c1 li-bullet-2">
            <span className="c0">
              &Eacute; pol&iacute;tica da HU Brasil o respeito &agrave;s normas
              de Prote&ccedil;&atilde;o de Dados e o cumprimento das leis e
              regulamentos aplic&aacute;veis
            </span>
          </li>
          <li className="c1 li-bullet-6">
            <span className="c0">
              O HU Digital poder&aacute;, mas n&atilde;o &eacute; obrigado a
              monitorar e restringir o acesso a qualquer de suas &aacute;reas
              onde os usu&aacute;rios trefeguem informa&ccedil;&otilde;es,
              podendo retirar do ar ou retirar o acesso a qualquer destas
              informa&ccedil;&otilde;es ou comunica&ccedil;&otilde;es em
              raz&atilde;o de seguran&ccedil;a e de uso adequado do sistema.
            </span>
          </li>
          <li className="c1 li-bullet-2">
            <span className="c0">
              Em caso de d&uacute;vidas, o usu&aacute;rio poder&aacute; entrar
              em contato com o HU Brasil, por meio da Ouvidoria, por meio do
              endere&ccedil;o eletr&ocirc;nico{" "}
              <a
                href="https://gov.br/ebserh/pt-br/acesso-a-informacao/participacao-social/ouvidoria-geral/ouvidoria"
                target="_blank"
                rel="noreferrer"
              >
                gov.br/ebserh/pt-br/acesso-a-informacao/participacao-social/ouvidoria-geral/ouvidoria
              </a>{" "}
              ,para que sejam realizadas as a&ccedil;&otilde;es
              necess&aacute;rias.
            </span>
          </li>
        </ol>

        <p className="c12">
          <span className="c0" />
        </p>
        <li className="c3 li-bullet-3">
          <span className="c4">
            <strong>Uso das contribui&ccedil;&otilde;es.</strong>
          </span>
        </li>
        <ol className="c5 lst-kix_list_2-1 start">
          <li className="c1 li-bullet-2">
            <span className="c0">
              Ao enviar uma contribui&ccedil;&atilde;o escrita ou postar
              informa&ccedil;&otilde;es no HU Digital, o usu&aacute;rio concede
              uma licen&ccedil;a perp&eacute;tua &agrave; HU Brasil, isenta de
              royalties e incondicional.
            </span>
          </li>
          <li className="c1 li-bullet-2">
            <span className="c0">
              Ao publicar a sua contribui&ccedil;&atilde;o no HU Digital, o
              usu&aacute;rio contribuir&aacute; para as medidas de sa&uacute;de
              p&uacute;blica de forma agregada (nunca individual), e que
              poder&atilde;o ser utilizadas ou referenciadas em
              publica&ccedil;&otilde;es cient&iacute;ficas e educacionais.
            </span>
          </li>
          <li className="c1 li-bullet-4">
            <span className="c0">
              O HU Digital tem o direito, mas n&atilde;o a
              obriga&ccedil;&atilde;o, de editar ou remover qualquer
              contribui&ccedil;&atilde;o, ou inclu&iacute;-la no texto em
              conjunto com outras contribui&ccedil;&otilde;es, a crit&eacute;rio
              exclusivo da HU Brasil.
            </span>
          </li>
        </ol>

        <p className="c12">
          <span className="c0" />
        </p>
        <li className="c3 li-bullet-5">
          <span className="c4">
            <strong>Garantia de Sigilo e Anonimato:</strong>
          </span>
        </li>
        <ol className="c5 lst-kix_list_2-1 start">
          <li className="c1 li-bullet-4">
            <span className="c0">
              Ser&aacute; garantido o sigilo e anonimato de todas as
              informa&ccedil;&otilde;es registradas pelo usu&aacute;rio no HU
              Digital, exceto, em decorr&ecirc;ncia de exig&ecirc;ncia legal.
            </span>
          </li>
          <li className="c1 li-bullet-4">
            <span className="c0">
              O HU Brasil reserva o direito de usar esta
              informa&ccedil;&atilde;o internamente e, nesse &acirc;mbito, sua
              contribui&ccedil;&atilde;o estar&aacute; sempre vinculada a dados
              anonimizados, em substitui&ccedil;&atilde;o aos dados pessoais dos
              usu&aacute;rios.
            </span>
          </li>
          <li className="c1 li-bullet-2">
            <span className="c0">
              O HU Brasil, em informa&ccedil;&otilde;es prestadas pelos
              usu&aacute;rios, n&atilde;o se responsabiliza por erros ou
              imprecis&otilde;es. Deturpa&ccedil;&atilde;o deliberada de
              informa&ccedil;&otilde;es por um usu&aacute;rio pode constituir
              viola&ccedil;&atilde;o da lei e poder&aacute; ser comunicada
              &agrave;s autoridades competentes.
            </span>
          </li>
        </ol>

        <p className="c12">
          <span className="c0" />
        </p>
        <li className="c3 li-bullet-3">
          <span className="c4">
            <strong>Atualiza&ccedil;&atilde;o do HU Digital:</strong>
          </span>
        </li>
        <ol className="c5 lst-kix_list_2-1 start">
          <li className="c1 li-bullet-2">
            <span className="c0">
              Modifica&ccedil;&otilde;es deste aplicativo e do seu Termo de Uso
              poder&atilde;o ocorrer. A menos que indique o contr&aacute;rio,
              seu uso representa a aceita&ccedil;&atilde;o integral do Termo de
              Uso na vers&atilde;o vigente. O usu&aacute;rio deve ficar atento
              &agrave;s atualiza&ccedil;&otilde;es e, em caso de d&uacute;vida,
              o Termo de Uso estar&aacute; sempre dispon&iacute;vel para acesso
              e concord&acirc;ncia ou n&atilde;o.
            </span>
          </li>
        </ol>

        <p className="c12">
          <span className="c0" />
        </p>
        <li className="c3 li-bullet-3">
          <span className="c4">
            <strong>
              Responsabilidade por a&ccedil;&otilde;es com base no
              conte&uacute;do:
            </strong>
          </span>
        </li>
        <ol className="c5 lst-kix_list_2-1 start">
          <li className="c1 li-bullet-4">
            <span className="c0">
              O HU Digital n&atilde;o assume responsabilidade por quaisquer
              preju&iacute;zos e/ou danos a pessoas ou bens, em
              consequ&ecirc;ncia da utiliza&ccedil;&atilde;o das ideias,
              conte&uacute;dos, instru&ccedil;&otilde;es, m&eacute;todos,
              produtos ou procedimentos contidos no aplicativo.
            </span>
          </li>
          <li className="c1 li-bullet-2">
            <span className="c0">
              Os profissionais envolvidos com o desenvolvimento ou gest&atilde;o
              deste aplicativo n&atilde;o ser&atilde;o responsabilizados por
              qualquer decis&atilde;o ou a&ccedil;&atilde;o tomada com base em
              tal conte&uacute;do.
            </span>
          </li>
          <li className="c1 li-bullet-2">
            <span className="c0">
              Diante de amea&ccedil;a ou qualquer outra situa&ccedil;&atilde;o
              de risco &agrave; sa&uacute;de ou integridade procure
              orienta&ccedil;&otilde;es validadas e atualizadas pelos
              servi&ccedil;os locais de sa&uacute;de p&uacute;blica.
            </span>
          </li>
        </ol>

        <p className="c12">
          <span className="c0" />
        </p>
        <li className="c3 li-bullet-1">
          <span className="c4">
            <strong>Responsabilidade por problemas tecnol&oacute;gicos:</strong>
          </span>
        </li>
        <ol className="c5 lst-kix_list_2-1 start">
          <li className="c1 li-bullet-2">
            <span className="c0">
              Eventualmente, todo o conte&uacute;do ou qualquer parte do HU
              Digital pode n&atilde;o estar dispon&iacute;vel ou n&atilde;o
              funcionar corretamente em decorr&ecirc;ncia de problemas
              tecnol&oacute;gicos, tais como v&iacute;rus, rotinas de
              programa&ccedil;&atilde;o prejudiciais ou problemas relacionados
              ao aparelho do usu&aacute;rio.
            </span>
          </li>
          <li className="c1 li-bullet-2">
            <span className="c0">
              O aplicativo &eacute; fornecido &quot;como est&aacute;&quot; e
              &quot;conforme estiver dispon&iacute;vel &quot;. O HU Brasil
              n&atilde;o garante a disponibilidade, integridade, pontualidade,
              funcionalidade, confiabilidade, sequenciamento ou a velocidade de
              entrega neste aplicativo ou de qualquer parte do conte&uacute;do.
            </span>
          </li>
          <li className="c1 li-bullet-6">
            <span className="c0">
              O HU Digital n&atilde;o se responsabiliza por qualquer dano ou
              preju&iacute;zo causado pelo desempenho ou falha de desempenho de
              toda ou qualquer parte do aplicativo. O HU Digital n&atilde;o se
              responsabiliza por quaisquer defeitos, atrasos ou erros
              resultantes da sua utiliza&ccedil;&atilde;o.
            </span>
          </li>
          <li className="c1 li-bullet-2">
            <span className="c0">
              A utiliza&ccedil;&atilde;o das funcionalidades do HU Digital exige
              disponibilidade do acesso &agrave; internet pelo usu&aacute;rio. A
              aus&ecirc;ncia desse pr&eacute;-requisito pode limitar sua
              utiliza&ccedil;&atilde;o em todo seu potencial. O HU Brasil
              n&atilde;o assume responsabilidade decorrente dessa
              limita&ccedil;&atilde;o.
            </span>
          </li>
          <li className="c8 c19 li-bullet-2">
            <span className="c0">
              Esta isen&ccedil;&atilde;o de responsabilidade aplica-se a todos e
              quaisquer danos ou preju&iacute;zos decorrentes de quaisquer
              eventos, assegurada a ado&ccedil;&atilde;o das medidas de
              seguran&ccedil;a, t&eacute;cnicas e administrativas aptas a
              proteger os dados pessoais de acessos n&atilde;o autorizados e de
              situa&ccedil;&otilde;es acidentais ou il&iacute;citas de
              destrui&ccedil;&atilde;o, perda, altera&ccedil;&atilde;o,
              comunica&ccedil;&atilde;o ou qualquer forma de tratamento
              inadequado ou il&iacute;cito, incluindo aqueles causados por
              qualquer falha de desempenho, erro, omiss&atilde;o,
              interrup&ccedil;&atilde;o, apagamento, defeito, atraso na
              opera&ccedil;&atilde;o ou transmiss&atilde;o, v&iacute;rus de
              computador, falha de linha de comunica&ccedil;&atilde;o, roubo,
              destrui&ccedil;&atilde;o ou acesso n&atilde;o autorizado, a
              altera&ccedil;&atilde;o ou uso de qualquer bem, seja por
              viola&ccedil;&atilde;o de contrato, comportamento il&iacute;cito,
              neglig&ecirc;ncia ou qualquer outra causa de a&ccedil;&atilde;o.
            </span>
          </li>
        </ol>

        <p className="c2 c13 c22">
          <span className="c0" />
        </p>
        <li className="c22 c26 li-bullet-3">
          <span className="c4">
            <strong>
              Responsabilidade por informa&ccedil;&otilde;es de terceiros:
            </strong>
          </span>
        </li>
        <ol className="c5 lst-kix_list_2-1 start">
          <li className="c1 li-bullet-2">
            <span className="c0">
              A disponibilidade atrav&eacute;s do aplicativo de links e
              refer&ecirc;ncias para outros sites, publica&ccedil;&otilde;es ou
              recursos de informa&ccedil;&atilde;o n&atilde;o constitui o
              endosso desses sites ou de seus recursos por parte do HU Digital,
              de seus agentes ou representantes.
            </span>
          </li>
        </ol>

        <p className="c12">
          <span className="c0" />
        </p>
        <li className="c3 li-bullet-3">
          <span className="c4">
            <strong>Considera&ccedil;&otilde;es Finais</strong>
          </span>
        </li>
        <ol className="c5 lst-kix_list_2-1 start">
          <li className="c1 li-bullet-2">
            <span className="c0">
              O acesso ao servi&ccedil;o do HU Digital representa a
              aceita&ccedil;&atilde;o expressa e irrestrita do Termo de Uso
              acima descrito. Ao concordar com este termo voc&ecirc; concede uma
              licen&ccedil;a perp&eacute;tua, isenta de royalties,
              licen&ccedil;a incondicional para o HU Digital, HU Brasil,
              Minist&eacute;rio da Educa&ccedil;&atilde;o, e todas as
              organiza&ccedil;&otilde;es sucessoras, para publicar a sua
              contribui&ccedil;&atilde;o de forma agregada, nunca
              individualizada, no pr&oacute;prio aplicativo, bem como
              divulg&aacute;-las aos servi&ccedil;os de sa&uacute;de
              p&uacute;blica relacionados. Voc&ecirc; tamb&eacute;m concorda que
              HU Digital tem o direito, mas n&atilde;o a
              obriga&ccedil;&atilde;o, de editar ou remover qualquer
              contribui&ccedil;&atilde;o a crit&eacute;rio exclusivo do HU
              Brasil.
            </span>
          </li>
          <li className="c1 li-bullet-2">
            <span className="c0">
              Este aplicativo n&atilde;o realiza diagn&oacute;stico
              cl&iacute;nico. Apenas auxilia o usu&aacute;rio na
              compreens&atilde;o dos sinais e sintomas relacionados &agrave;s
              defini&ccedil;&otilde;es operacionais, de sa&uacute;de
              p&uacute;blica, para acompanhamento do seu
              estado/condi&ccedil;&atilde;o de sa&uacute;de.
            </span>
          </li>
          <li className="c8 c19 li-bullet-2">
            <span className="c0">
              Em caso de d&uacute;vidas, o usu&aacute;rio poder&aacute; entrar
              em contato com o HU Brasil, por meio da Ouvidoria, para que sejam
              realizadas as a&ccedil;&otilde;es necess&aacute;rias,
              dispon&iacute;vel no endere&ccedil;o eletr&ocirc;nico{" "}
              <a
                href="https://gov.br/ebserh/pt-br/acesso-a-informacao/participacao-social/ouvidoria-geral/ouvidoria"
                target="_blank"
                rel="noreferrer"
              >
                gov.br/ebserh/pt-br/acesso-a-informacao/participacao-social/ouvidoria-geral/ouvidoria
              </a>
              .
            </span>
          </li>
        </ol>
      </ol>
    </>
  );
}
